// Refusal codes the App Backend returns on volunteer sign-up / admin add-to-shift
// (Volunteers Plan B, task A4). The backend normally sends a plain-English `message`
// with the code; these are only used if it does not, so a raw code is never shown.
export const VOLUNTEER_REFUSALS: Record<string, string> = {
  NotCleared:
    'Your volunteering checks (PVG and induction) are not recorded yet. The volunteer coordinator will be in touch.',
};

export const STAFF_REFUSALS: Record<string, string> = {
  NotCleared:
    'This volunteer cannot be added to a shift yet: their PVG and induction are not both recorded in the CRM.',
};

export function volunteerErrorMessage(
  err: any,
  fallback: string,
  refusals: Record<string, string> = VOLUNTEER_REFUSALS,
): string {
  const data = err?.response?.data;
  if (typeof data?.message === 'string' && data.message) return data.message;
  const code = data?.error;
  if (typeof code !== 'string') return fallback;
  if (refusals[code]) return refusals[code];
  // Today's errors are sentences ("Shift is at full capacity"); a bare word is a code.
  return /\s/.test(code) ? code : fallback;
}
